/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

export { TextDirection } from './TextDirection.js';
export { Text } from './Text.js';
import { createTextComponent } from './createTextComponent.js';

createTextComponent('label', 'Label');
const Legend = createTextComponent('legend', 'Legend');

export { Legend };
